// initialization
document.documentElement.setAttribute('data-bs-motion','reduced-motion')
document.documentElement.setAttribute('data-bs-theme','light')
document.getElementById("mySwitchMotion").checked = true;

// click handlers
document.getElementById('mySwitchMotion').addEventListener('click',()=>{
    if (document.documentElement.getAttribute('data-bs-motion') == 'motion') {
        document.documentElement.setAttribute('data-bs-motion','reduced-motion')
    }
    else {
        document.documentElement.setAttribute('data-bs-motion','motion')
    }
})
document.getElementById('mySwitchMotion2').addEventListener('click',()=>{
    if (document.documentElement.getAttribute('data-bs-motion') == 'motion') {
        document.documentElement.setAttribute('data-bs-motion','reduced-motion')
    }
    else {
        document.documentElement.setAttribute('data-bs-motion','motion')
    }
})